import styled from '@emotion/styled';

export const UpdateRecipeDetailsPage = styled.div`
  padding: 32px;
`;

export const Inputs = styled.div`
  display: flex;
  gap: 0 24px;
  margin: 16px 0;
`;

export const HorizontalLine = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.gray400};
  margin: 32px 0;
`;

export const FprodInputs = styled.div`
  padding: 16px 0;
  gap: 32px 0;
  display: flex;
  flex-direction: column;
`;

export const Buttons = styled.div`
  margin-top: 64px;
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
`;
